import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import ChartFactory from "@/components/VueCharts/ChartFactory.vue";
let UserStatistics = class UserStatistics extends Vue {
    factoryData = [];
    loading = false;
    value;
    get statisticsDialog() {
        return this.value;
    }
    set statisticsDialog(value) {
        this.$emit('input', value);
    }
    get userLoggedIn() {
        return this.$store.getters['user/isLoggedIn'];
    }
    get isDevelopment() {
        return process.env.VUE_APP_PROJECT_ID === 'skistem-test';
    }
    async fetchData() {
        if (!this.statisticsDialog) {
            return;
        }
        this.loading = true;
        const url = process.env.VUE_APP_BI_URL + '/process-instructor';
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(await this.getBiData()),
        });
        this.factoryData = await response.json();
        this.loading = false;
    }
    async getBiData() {
        return {
            instructor_id: await this.$store.getters['user/userId'],
            balances: await this.$store.getters['balance/all'],
            instructors: await this.$store.getters['instructor/all'],
            transactions: await this.$store.getters['transaction/fetchAll'],
            works: await this.$store.getters['instructorTable/fetchAll'],
            prices: await this.$store.getters['pricing/all'],
        };
    }
};
__decorate([
    Prop({ required: true })
], UserStatistics.prototype, "value", void 0);
__decorate([
    Watch('value')
], UserStatistics.prototype, "fetchData", null);
UserStatistics = __decorate([
    Component({
        components: { ChartFactory }
    })
], UserStatistics);
export default UserStatistics;
